import { useQuery } from "@tanstack/react-query";
import { appointmentService } from "..";
import { AppointmentQueueListParams } from "@/models/club";

type Props = {
  command: AppointmentQueueListParams;
};

const useGetAppointmentDeposit = ({ command }: Props) =>
  useQuery({
    queryKey: [
      "getAppointmentDeposit",
      command.Count,
      command.Skip,
      command.Status,
      command.CustomerId,
      command.MerchantUserId,
      command.CreationTimeFrom,
      command.CreationTimeTo,
      command.HasSettlement,
      command.SnappPayTransactionId,
    ],
    queryFn: () => appointmentService.getAppointmentDeposit(command),
    select: (res) => res,
  });

export { useGetAppointmentDeposit };
